export default __webpack_public_path__ + "media/images/images_v2/border-right2-5e2583b0af2ecfcbc1d7405345725267.png";